<template>
    <div>
        <el-row>
            <el-col :span="24" >
                <el-table
                    :data="itemList"
                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                    v-loading="loading">
                    <el-table-column
                        prop="shopName"
                        label="shopName">
                    </el-table-column>
                    <el-table-column
                        prop="countOrder"
                        label="จำนวนออเดอร์"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="courierId"
                        label="ขนส่ง"
                        width="180">
                        <template slot-scope="scope">
                            <el-tag v-bind:style="getCourierObject(scope.row.courierId).styleTag">{{ getCourier(scope.row.courierId) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="สถานะ"
                        width="180">
                        <template slot-scope="scope">
                            {{ (scope.row.status)? scope.row.status : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="bookTime"
                        label="เวลา"
                        width="180">
                        <template slot-scope="scope">
                            {{ (scope.row.bookTime)? scope.row.bookTime : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="remark"
                        width="180">
                        <template slot-scope="scope">
                            {{ (scope.row.remark)? scope.row.remark : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label=""
                        width="180">
                        <template slot-scope="scope">
                            <el-button type="primary" icon="el-icon-edit" @click="showOrder(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;" class="text-md-center">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit"
                ></el-pagination>
            </el-col>
        </el-row>
        <dialog-order-list :dialogShopOrder.sync="dialogShopOrder" @refreshShopList="onRefreshListShop"/>
    </div>
</template>
<script>
import dialogOrderList from '@/components/LogOrder/dialogShopOrderMobile.vue'
import fgApi from '@/services/fillgoods'
import { CancelToken } from 'axios'
export default {
    name: 'mobileShop',
    components: { dialogOrderList },
    data () {
        return {
            itemList: [],
            loading: false,
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            dialogShopOrder: {
                dialogShow: false,
                detail: {},
                date: null
            },
            cancelTokenFetchTabStatus: null
        }
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.$emit('onSearch')
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.$emit('onSearch')
        },
        async fetchShopSearch (search = null, date) {
            this.loading = true
            this.dialogShopOrder.date = date
            try {
                if (this.cancelTokenFetchTabStatus) {
                    this.cancelTokenFetchTabStatus.cancel()
                }
                this.cancelTokenFetchTabStatus = CancelToken.source()
                let param = {
                    date: date,
                    search: search,
                    offset: this.pagination.offset,
                    limit: this.pagination.limit
                }
                let res = await fgApi.log.searchMobileShop(param, this.cancelTokenFetchTabStatus.token)
                console.log(res)
                if (res.success) {
                    this.pagination.allPage = res.allPage
                    this.itemList = res.data
                }
            } catch (error) {
                if (CancelToken.isCancel(error)) { return }
                this.$notify.error({
                    title: 'Error',
                    message: 'API Error !'
                })
            }
            this.loading = false
        },
        showOrder (data) {
            this.dialogShopOrder.dialogShow = true
            this.dialogShopOrder.detail = data
            console.log(data)
        },
        onRefreshListShop () {
            this.$emit('onSearch')
        }
    }
}
</script>
